// src/components/common/Header.tsx
import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Menu, LogOut, User } from "lucide-react";

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-primary text-white shadow-lg sticky top-0 z-30">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <Menu size={24} />
          </button>

          {/* Logo Section */}
          <div className="flex items-center gap-3">
            <img
              src="/light_logo.png"
              alt="Logo"
              className="h-12 w-auto object-contain"
            />
            {/* <h1 className="text-xl font-bold hidden sm:block">
              Admin Dashboard
            </h1> */}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
              <User className="w-5 h-5 text-primary" />
            </div>
            <div className="min-w-0 flex-1 hidden sm:block">
              <p className="text-sm font-semibold text-white truncate">
                {user?.name || "Admin User"}
              </p>
              <p className="text-xs text-white truncate">
                {user?.email || "admin@example.com"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
